import styled from "styled-components";

export const TickerText = styled.p`
  margin: 0;
  color: white;
  font-size: 2rem;
  white-space: nowrap;
  padding-right: 0.3rem;
  margin-bottom: -1rem;
  display: flex;
  align-items: center;

  @media (max-width: 48rem) {
    font-size: 1rem;
    margin-bottom: 1rem;
  }
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 3.8rem;
  color: white;
  letter-spacing: 1%;

  @media (max-width: 48rem) {
    font-size: 2rem;
  }
`;

export const Subtitle = styled.h2`
  margin: 0;
  margin-top: 1rem;
  color: white;
  font-size: 2.8rem;
  letter-spacing: 2%;
  width: 100%;

  text-align: justify;

  @media (max-width: 48rem) {
    font-size: 2rem;
  }
`;

export const Slogan = styled.p`
  font-size: 1.9rem;
  color: white;
  letter-spacing: 1%;
  font-style: italic;

  @media (max-width: 48rem) {
    font-size: 2rem;
  }
`;
